import qs from 'qs';

import ApiService from 'services/ApiService/ApiService';
import ConfigurationService, { ConfigurationKeys } from 'services/ConfigurationService';
import { translate } from 'services/i18nService';
import MessagingService from 'services/MessagingService/MessagingService';
import {
  SET_BROADCASTER_MODERATION_ERROR_VALUE,
  CLOSE_BROADCASTER_SEARCH,
} from 'services/MessagingService/EventNames';
import NotificationService from 'services/NotificationService';
import { MODERATION_OPTIONS } from 'utils/consts';
import parseCatch from 'utils/parseCatch';


const WEBCHAT_HOST = ConfigurationService.get(ConfigurationKeys.WEB_CHAT_HOST);
const WEBCHAT_SEND_NOTIFICATION = `${WEBCHAT_HOST}sendNotification`;

/**
 * @class handles business logic for moderation broadcaster and expose methods
 */
class ModerationService {
  constructor(messagingService) {
    this.messagingService = messagingService();
  }

  /**
   * Method for updating user status in room(moderator, silence, ban)
   * @param {recipient} recipient - targeted username
   * @param {type} string - action(silence, unsilence, ban, unban, moderator, remove_moderator)
   * @param {accessHash} bool - logged in accessHash
   * @param {username} string - logged in username
   * @param {roomname} string - current roomname
   * @emits SET_BROADCASTER_MODERATION_ERROR_VALUE setting the error if there is no user with target username
   * @emits CLOSE_BROADCASTER_SEARCH closes the custom search broadcaster search
   */
  moderateUser = ({ recipient, type, accessHash, username, roomname }, isContextualMenu) => {
    const headers = { 'content-type': 'application/x-www-form-urlencoded' };
    const data = {
      recipient,
      type,
      accessHash,
      username,
      roomname,
    };

    ApiService.post(encodeURI(WEBCHAT_SEND_NOTIFICATION), { data: qs.stringify(data), headers })
      .then((res) => {
        if (res.data.status === 'notAValidUser') {
          this.messagingService.emit(SET_BROADCASTER_MODERATION_ERROR_VALUE, true);
        } else if (isContextualMenu) {
          NotificationService.create({
            type: NotificationService.type.TOAST,
            text: this._createNotificationText(type, recipient),
            subtype: NotificationService.subtype.SUCCESS,
          });
        } else {
          this.messagingService.emit(CLOSE_BROADCASTER_SEARCH);
        }
      })
      .catch((err) => {
        parseCatch(err);
      });
  };


  /**
   * Private method for displaying relevant notification text
   * @param {recipient} recipient - targeted username
   * @param {type} string - action(silence, unsilence, ban, kick, moderator, remove_moderator)
   */
  _createNotificationText = (type, recipient) => {
    switch (type) {
      case MODERATION_OPTIONS.MODERATOR:
        return translate('v2broadcast.assigned.as.moderator', { 0: recipient });
      case MODERATION_OPTIONS.REMOVE_MODERATOR:
        return translate('v2broadcast.unassigned.as.moderator', { 0: recipient });
      case MODERATION_OPTIONS.SILENCE:
        return translate('v2broadcast.user.silenced', { 0: recipient });
      case MODERATION_OPTIONS.UNSILENCE:
        return translate('v2broadcast.user.unsilenced', { 0: recipient });
      case MODERATION_OPTIONS.KICK:
        return translate('v2broadcast.user.kicked', { 0: recipient });
      case MODERATION_OPTIONS.BAN:
        return translate('v2broadcast.user.banned', { 0: recipient });
      default:
        return null;
    }
  };
}

export default new ModerationService(MessagingService);
